import i18n from 'i18n-literally'

import { EMPTY_OBJECT } from '~/src/Lib/Utils'

export const interruptionTitle = interruptionType => (props, interruption = interruptionType) => {
  const { annotation, entities } = props
  const { devices = EMPTY_OBJECT, models = EMPTY_OBJECT } = entities
  const { data, device: deviceId, subject } = annotation
  const { [deviceId]: device } = devices
  const { [device?.modelKey]: model } = models

  let serialNumber = data?.serialNumber ?? device?.serialNumber
  let deviceName = data?.deviceName
  if (device && device.puck) {
    const { [device.puck]: puck } = devices
    /* istanbul ignore else */
    if (puck) {
      serialNumber = serialNumber ?? puck.serialNumber
      deviceName = deviceName ?? puck.deviceName
    }
  }
  const modelName = data?.modelName ?? model?.name

  if (serialNumber && (deviceName === serialNumber || !deviceName)) {
    return modelName
      ? i18n`${modelName} (${serialNumber}) ${interruption}`
      : i18n`${serialNumber} sensor ${interruption}`
  }

  if ([serialNumber, deviceName].some(Boolean)) {
    return serialNumber && deviceName
      ? i18n`${deviceName} (${serialNumber}) ${interruption}`
      : i18n`${deviceName} ${interruption}`
  }

  return subject
}

export const keyToTitle = {
  DEVICE_UNPLUGGED: interruptionTitle('unplugged'),
  DEVICE_DISCONNECTED: interruptionTitle('disconnected'),
  GATEWAY_DISCONNECTED: props => {
    const { annotation, entities } = props
    const { devices = EMPTY_OBJECT } = entities
    const { data, device: deviceId, subject } = annotation
    const { [deviceId]: device } = devices

    /* istanbul ignore next */
    if (!data && !device) return subject

    const deviceName = data?.deviceName ?? device?.deviceName
    const serialNumber = data?.serialNumber ?? device?.serialNumber

    const name = deviceName === serialNumber
      ? serialNumber
      : deviceName

    /* istanbul ignore next */
    if (!name) return subject

    return `Gateway ${name} disconnected`
  },
  PUCK_DISCONNECTED: props => {
    const { annotation, entities } = props
    const { devices = EMPTY_OBJECT } = entities
    const { data, device: deviceId, subject } = annotation
    const { [deviceId]: device } = devices

    /* istanbul ignore next */
    if (!device && !data) return subject

    const serial = data?.serialNumber ?? device?.serialNumber

    /* istanbul ignore next */
    if (!serial) return subject

    return `${serial} disconnected`
  },
}

export const interruptionFormatterUtil = props => {
  const { annotation, entities } = props
  const { devices = EMPTY_OBJECT } = entities
  const { device: deviceId, key, subject, message } = annotation
  const { [deviceId]: device } = devices

  let title = subject
  if (key in keyToTitle) {
    const titleFormatter = keyToTitle[key]
    title = titleFormatter(props)
  }

  return {
    title,
    body: device ? '' : message
  }
}
